<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay> -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty Notice</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
                <v-radio-group inline v-model="radio" row>
                    <v-radio label="Send Notice" value="send"></v-radio>
                    <v-radio label="Fetch Notice" value="fetch"></v-radio>
                </v-radio-group>
            </v-row>
            <v-card flat class="" v-if="radio=='send'">
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay"
                            item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required @change="getInst()" v-model="emp_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined>
                        </v-autocomplete>
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required @change="getInst()" v-model="designation"
                            :items="designation_list" item-value="id" item-text="name" label="Designation"
                            outlined></v-autocomplete>
                    </v-col>
                    <v-col sm="2" v-if="inst_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete dense required v-model="inst" :items="inst_list" return-object item-text="name"
                            label="Instructor" outlined multiple></v-autocomplete>
                    </v-col>
                </v-row>
                <br />
                <!-- <v-row justify="center">
                        <v-col cols="12" sm="2">
                            <v-text-field outlined dense type="date" v-model="fromdate" label="From Date(inclusive)" hint="From Date"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field outlined dense type="date" v-model="todate" label="To Date(exclusive)" hint="To Date"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
                        </v-col>
                    </v-row> -->
                <v-row dense justify="center">
                    <v-col cols="6">
                        <v-text-field dense rounded outlined label="Title" v-model="title" :rules="textRule" required
                            placeholder="Colleges reopens">
                            <template v-slot:prepend>
                                <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field dense rounded outlined label="Link(If Any)" v-model="link" placeholder="URL"
                            @change="validateWebinarURL(link)"></v-text-field>
                    </v-col>
                </v-row>
                <v-col cols="12">
                    <v-textarea dense rounded outlined label="Description" v-model="description" value
                        placeholder="Colleges reopens on...."
                        hint="Enter description of notice or home work"></v-textarea>
                </v-col>
                <v-col cols="12">
                    <v-file-input dense rounded outlined v-model="attachments" placeholder="Upload attachment if any"
                        label="Attachment" multiple prepend-icon="mdi-paperclip">
                        <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">{{ text }}</v-chip>
                        </template>
                    </v-file-input>
                </v-col>

                <v-btn @click="putNoticeToInst()" :loading="send_btn_load" v-if="title" color="info">Send</v-btn>
            </v-card>
            <v-card flat class="" v-if="radio=='fetch'">
                <v-row justify="center">
                    <v-col cols="12" sm="2">
                        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date(inclusive)"
                            hint="From Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field outlined dense type="date" v-model="todate" label="To Date(exclusive)"
                            hint="To Date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <!-- <p><br></p> -->
                        <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="communication_list != ''" justify="center">
                    <v-col cols="12" sm="12" md="12">
                        <v-data-table :items="bookList1" :headers="headers" class="elevation-1 mytable" :search="search"
                            @current-items="getFiltered">
                            <template v-slot:top>
                                <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
                                    <v-toolbar-title><b>List of Notices</b> </v-toolbar-title>
                                    <v-spacer></v-spacer>

                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field v-model="search" append-icon="search" label="Search" rounded
                                            background-color="white" color="white" hide-details></v-text-field>
                                    </v-col>
                                </v-toolbar>
                                <v-row dense>
                                    <tr class="t-row">
                                        <div>
                                            <th>
                                                <v-row>
                                                    <span v-for="header in headers" :key="header.text">
                                                        <span v-if="filters.hasOwnProperty(header.value)">
                                                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details
                                                                small rounded dense outlined color="#0F2027"
                                                                :label="header.text" multiple clearable
                                                                :items="columnValueList(header.value)"
                                                                v-model="filters[header.value]"></v-autocomplete>
                                                        </span>
                                                    </span>
                                                </v-row>
                                            </th>
                                        </div>
                                    </tr>
                                </v-row>
                            </template>

                            <template v-slot:[`item.url`]="{ item }">
                                <span v-if="item.url != '--'">
                                    <a :href="item.url" target="_blank">
                                        <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                                    </a>
                                </span>
                                <span v-else style="opacity: 0.5;">{{ item.url }}</span>
                            </template>
                            <template v-slot:[`item.attachment`]="{ item }">
                                <span v-if="item.attachment_list.length > 0">
                                    <span v-for="(item, i) in item.attachment_list" :key="i">
                                        <a class="p-2" :href="basepath + item.link" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ attrs }">
                                                    <v-btn icon v-if="item.link != null" v-bind="attrs">
                                                        <v-icon color="black">mdi-eye</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span> View Attachment File!!! </span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                </span>
                            </template>
                            <template v-slot:[`item.edit`]="{ item }">
                                <div>
                                    <v-btn color="secondary" icon dark @click="editDialog(item)" title="Edit Event">
                                        <v-icon>mdi-file-document-edit</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:[`item.delete`]="{ item }">
                                <div>
                                    <v-btn color="warning" icon dark @click="deleteCalendarEvent(item)"
                                        title="Delete Event" :loading="delete_attach_load">
                                        <v-icon>mdi-delete-empty</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            <template v-slot:[`item.read_by_parent`]="{ item }">
                                <div>
                                    <v-icon medium class="mr-2" @click="getStatus(item.id)"> mdi-eye-outline</v-icon>
                                </div>
                            </template>
                            <template v-slot:[`item.description`]="{ item }">
                                <div v-if="item.description!=null || item.description!=''">
                                    <v-icon medium class="mr-2" @click="getdescription(item.description)">
                                        mdi-eye-outline</v-icon>
                                </div>
                                <div v-else>
                                    --
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card>
            <v-dialog v-model="status_dialog" max-width="1200px">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="status_headers" :items="comm_read_status" :search="search">
                            <template v-slot:top>
                                <v-toolbar flat color="white" align="center" justify="center">
                                    <v-toolbar-title>List of Receipients</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <strong>Total Receipients- </strong>{{ total_receipients }}
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn class="dialog-btn" @click="status_dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="edit_dialog" max-width="500px">
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense hint="cannot edit" disabled v-model="editedItem.date"
                                        label="Sent Date"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense hint="cannot edit" disabled v-model="editedItem.from"
                                        label="From"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense hint="cannot edit" disabled v-model="editedItem.to"
                                        label="To"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense hint="editable" v-model="editedItem.title"
                                        label="Title"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense hint="editable" v-model="editedItem.url"
                                        label="Link"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea label="Description" v-model="editedItem.description" dense
                                        placeholder="Colleges reopens on...." hint="editable"></v-textarea>
                                </v-col>
                            </v-row>
                            <v-col cols="12">
                                <v-file-input v-model="edit_attachments" placeholder="Upload attachment if any"
                                    label="Attachment" multiple prepend-icon="mdi-paperclip">
                                    <template v-slot:selection="{ text }">
                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                    </template>
                                </v-file-input>
                            </v-col>
                            <template v-if="editedItem.attachment_list.length > 0">
                                <h3>Attachments</h3>
                                <ol>
                                    <li v-for="attach in editedItem.attachment_list" :key="attach.attach_id">
                                        <a :href="awspath + attach.link">{{ attach.attach_name }}</a>
                                        <v-btn text title="Delete attachment" :loading="delete_acttach_load"
                                            @click="deleteAttachment(attach)">
                                            <v-icon color="red">mdi-window-close</v-icon>
                                        </v-btn>
                                    </li>
                                </ol>
                            </template>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="edit_dialog = false">Cancel</v-btn>
                        <v-btn color="blue darken-1" :loading="edit_save_attachment_load" text
                            @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogshowdescription" max-width="1200px">
                <v-card class="box">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title class="px-0">Description</v-toolbar-title>
                    </v-toolbar>
                    <br>
                    <v-card-text>
                        <strong>
                            <span v-html="showdescription"></span>
                        </strong>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn class="dialog-btn" @click="dialogshowdescription = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            file_upload_config: {
                allowed_type: "",
                max_size: 1000,
            },
            radio: null,
            rules: [(value) => !value || value.size < 2000000 || "Logo size should be less than 2 MB!"],
            textRule: [(v) => !!v || "Field is required"],
            attachments: [],
            ay_list: [],
            // extraBreadcrumbItems: [


            // ],
            breadcrumbClass: "breadcrumb-style1",
            academicyear: null,
            employee_type_list: [],
            emp_type: [],
            designation_list: [],
            designation: [],
            description: null,
            link: null,
            fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            todate: new Date().toISOString().slice(0, 10),
            from_date: null,
            to_date: null,
            total_receipients: null,
            dialogshowdescription: false,
            showdescription: null,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            title: null,
            inst: [],
            inst_list: [],
            basepath: null,
            send_btn_load: false,
            status_dialog: false,
            communication_list: [],
            comm_read_status: [],
            filters: {
                title: [],
                date: [],
            },
            edit_save_attachment_load: false,
            edit_attachments: [],
            edit_dialog: false,
            delete_attach_load: false,
            editedItem: {
                date: null,
                attachment_list: [],
                description: null,
                from: null,
                id: null,
                to: null,
                title: null,
                url: null,
            },
            status_headers: [
                { text: "Sr No", value: "srno", sortable: true },
                { text: "Read By", value: "instructor", sortable: true },
                { text: "Read Date", value: "read_date", sortable: true },
            ],
            headers: [
                {
                    text: "Sent Date",
                    value: "date",
                    sortable: true,
                },
                {
                    text: "From",
                    value: "from",
                    sortable: true,
                },
                {
                    text: "Designation",
                    value: "designation",
                    sortable: true,
                },
                {
                    text: "Title",
                    value: "title",
                    sortable: true,
                },
                {
                    text: "Description",
                    value: "description",
                    sortable: true,
                },
                {
                    text: "Attachments",
                    value: "attachment",
                    sortable: true,
                },
                {
                    text: "Link",
                    value: "url",
                    sortable: true,
                },
                {
                    text: "View Status",
                    value: "read_by_parent",
                    sortable: true,
                },
                {
                    text: "Edit",
                    value: "edit",
                    sortable: false,
                },
                {
                    text: "Delete",
                    value: "delete",
                    sortable: false,
                },
            ],
        }),
        watch: {},
    methods: {
        getdescription(description) {
            this.showdescription = description;
            this.dialogshowdescription = true;
         },
            getStatus(id) {
                const formData = {
                    comm_id: id,
                };
                axios
                    .post("/Communication/getFacultycommunicationStatus", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.comm_read_status = res.data.read_list;
                            this.status_dialog = true;
                            this.total_receipients = res.data.total_receipients;
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.status_dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            save() {
                this.edit_save_attachment_load = true;
                let formData = new FormData();
                for (var i = 0; i < this.edit_attachments.length; i++) {
                    let file = this.edit_attachments[i];

                    formData.append("files", file);
                }
                formData.append("title", this.editedItem.title);
                formData.append("link", this.editedItem.url);
                formData.append("description", this.editedItem.description);
                formData.append("comm_id", this.editedItem.id);
                axios
                    .post("/communicationType/saveEditNotice", formData)
                    .then((res) => {
                        if (res.data.status == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Notice Updated Successfully..."); // show snackbar on success
                            this.edit_dialog = false;
                            this.get_ay_std();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                            //alert(res.data.status_reason)
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.edit_save_attachment_load = false;
                        this.edit_attachments = [];
                        this.close();
                        this.edit_dialog = false;
                    });
            },
            deleteAttachment(attach) {
                if (!confirm("Are You Sure You Want To Delete This Communication?")) return;
                const formData = {
                    attach_id: attach.attach_id,
                };
                this.delete_acttach_load = true;
                axios
                    .post("/communicationType/deleteAttachment", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.delete_acttach_load = false;
                            this.showSnackbar("green", "Attachment Deleted Successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                            //alert(res.data.status_reason)
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_acttach_load = false;
                    });
            },
            deleteCalendarEvent(item) {
                if (!confirm("Are You Sure You Want To Delete This Communication?")) return;
                this.delete_attach_load = true;
                const formData = {
                    comm_id: item.id,
                };
                axios
                    .post("/communicationType/deleteCommunicationInstructor", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
                            //alert(res.data.status_reason)
                          
                            this.get_ay_std();
                            //this.event_type.splice(index, 1);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                            //alert(res.data.status_reason)
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_attach_load = false;
                        this.fetchNotices()
                    });
            },
            editDialog(item) {
                this.awspath = localStorage.getItem("awspath");
                this.editedItem = item;
                this.edit_dialog = true;
                this.editItemIndex = this.communication_list.indexOf(item);
                //alert(this.editItemIndex)
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.communication_list.map((d) => d[val]);
            },
            fetchNotices() {
                this.init_loader = true;
                const formData = {
                    comm_type: "Notice",
                    for: "instructor",
                    fromdate: this.fromdate,
                    todate: this.todate,
                    ay: this.academicyear.id,
                };
                axios
                    .post("/Communication/getNoticesBetweenDates", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.d_ay = res.data.d_ay;
                            this.from_date = res.data.from_date;
                            this.to_date = res.data.to_date;
                            this.communication_list = res.data.instructor_communication_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.init_loader = false;
                    });
            },
            validateWebinarURL(link) {
                // alert("validateWebinarURL::" + link);

                var myURL = link;
                var mytrimurl = myURL.trim();
                var pattern = new RegExp(
                    "^((ft|htt)ps?:\\/\\/)?" + // protocol
                    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
                    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                    "(\\:\\d+)?" + // port
                    "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
                    "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
                        "(\\#[-a-z\\d_]*)?$",
                    "i"
                ); // fragment locator');
                if (this.hasWhiteSpace(this.myURL)) {
                    this.isvalid = true;
                    return;
                } else if (pattern.test(mytrimurl)) {
                    this.isvalid = true;
                    return;
                } else {
                    this.isvalid = false;
                    alert("Please Enter Valid URL...!");

                    return;
                }
            },
            hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            clearData() {
                (this.title = null), (this.link = null), (this.description = null), ((this.attachments = []), (this.inst = []));
            },

            putNoticeToInst() {
                if (this.hasWhiteSpace(this.title) || this.title == null) {
                    this.showSnackbar("#b71c1c", "Please Enter Title");
                    return;
                }
                this.send_btn_load = true;
                let formData = new FormData();
                for (var i = 0; i < this.attachments.length; i++) {
                    let file = this.attachments[i];
                    formData.append("files", file);
                }
                for (var i = 0; i < this.inst.length; i++) {
                    let inst = this.inst[i].id;
                    formData.append("instructor", inst);
                }
                formData.append("ay", this.academicyear.id);
                formData.append("title", this.title);
                formData.append("link", this.link);
                formData.append("description", this.description);
                formData.append("type", "Notice");
                formData.append("emp_type", this.emp_type);
                formData.append("designation", this.designation);
                axios
                    .post("/Communication/putNoticeToFaculty", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("green", "Sent Successfully...");
                            this.send_btn_load = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.send_btn_load = false;
                        this.get_ay_std();
                        this.clearData();
                    });
            },

            getInst() {
                if (this.designation == "" || this.emp_type == "") {
                    return;
                }
                (this.inst = null), (this.inst_list = null);
                const data = {
                    emp_type: this.emp_type,
                    designation: this.designation,
                };
                axios
                    .post("/Communication/getEmployees", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.inst_list = res.data.instructor_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {});
            },
            get_ay_std() {
                this.init_loader = true;
                const formData = {
                    comm_type: "Notice",
                    for: "instructor",
                };
                axios
                    .post("/Communication/gerInitialData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.academicyear = res.data.current_ay);
                            this.employee_type_list = res.data.employee_type_list;
                            this.designation_list = res.data.designation_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.init_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
        mounted() {
            this.init_loader = true;
            this.get_ay_std();
            this.basepath = localStorage.getItem("awspath");
        },
        computed: {
            bookList1() {
                return this.communication_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
    };
</script>

<style scoped>
    .allot-btn,
    .allot-icon,
    .info-icon {
        transition: 0.3s;
    }

    .allot-btn:hover .allot-icon {
        color: white;
    }

    .allot-btn:hover {
        background-color: #193a9a !important;
        border-color: #193a9a !important;
        color: white;
    }

    .info-icon:hover {
        background-color: #193a9a !important;
        border-color: #193a9a !important;
        color: white;
        border-radius: 100%;
    }

    .table-sub-title {
        margin-left: 1%;
        font-weight: 500;
        color: #999;
    }

    @media print {
        body {
            height: 100%;
            width: 100%;
        }

        .no-display {
            display: none !important;
        }

        .v-data-footer,
        .v-data-footer__select,
        .v-data-footer__pagination {
            display: none !important;
            visibility: hidden !important;
        }

        .v-data-table table,
        .v-data-table__wrapper {
            width: 100% !important;
            display: block !important;
        }

        table,
        th,
        td {
            border-collapse: collapse !important;
            border: 1px solid black !important;
            width: 100%;
            text-align: right !important;
        }
    }
</style>
